module.exports = __webpack_public_path__ + "img/source05_02.8d694a35.png";